<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="configuracoes.content"
      :expanded.sync="expanded"
      class="elevation-1 mt-5 rounded-card card-shadow"
      :loading="loading"
      :server-items-length="configuracoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma configuração encontrada"
      loading-text="Carregando configurações..."
      :options="optionsList"
    >
      <template v-slot:item.requerAprovacaoTotal="{ item }">
        <px-sim-nao :ativo="item.requerAprovacaoTotal"/>
      </template>
      <template v-slot:item.options="{ item }"
        v-if="hasRoleGestorCompras">
        <v-btn icon @click="goToEdit(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    configuracoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Empresa',
          value: 'comprador.pessoa.nome',
        },
        {
          text: 'Requer aprovação total',
          value: 'requerAprovacaoTotal',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorCompras']),
    comprador() {
      return item => Vue.filter('truncate')(item.comprador.pessoa.nome, 20);
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    goToEdit(item) {
      this.$router.push({
        name: 'main.configuracoes-aprovacao.edicao',
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>
